import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import dayjs, { Dayjs } from 'dayjs';
import { Tooltip, styled } from '@mui/material';

import { CustomButton, CustomInput, Picker } from '../../../shared/uiComponents';
import { findDuration } from '../../Calendar/Helpers/functions';

import { DispatchProperties, useSelector } from '../../../redux/store';
import { setEndTime, setStartTime } from '../../../redux/State/clientSlice/sessionSlice';
import { InfoFilled } from '../../../shared/Assets/svgIcons';

const TimeWrapper = styled('div')(() => ({
	display: 'flex',
	gap: '32px',
	width: '100%',
	flexWrap: 'wrap',
	alignItems: 'center',
}));

const TimeInfo = ({ disabled, save }: { disabled?: boolean; save?: () => void }) => {
	const dispatch = useDispatch<DispatchProperties>();

	const { date, startTime, endTime } = useSelector((state) => state.session.sessionInfo);
	const noteDate = date ? date.split('T')[0] : '';

	const [hasTimeChanged, setHasTimeChanged] = useState<boolean>(false);

	useEffect(() => {
		if (!hasTimeChanged || !save) return;
		save();
		setHasTimeChanged(false);
	}, [hasTimeChanged, save]);

	const startTimeHandler = (value: Dayjs | null) => {
		if (!value) return;
		const startTimeValue = value.format().slice(10, 19);
		dispatch(setStartTime(`${noteDate}${startTimeValue}`));
		setHasTimeChanged(true);
	};

	const endTimeHandler = (value: Dayjs | null) => {
		if (!value) return;
		const endTimeValue = value.format().slice(10, 19);
		dispatch(setEndTime(`${noteDate}${endTimeValue}`));
		setHasTimeChanged(true);
	};

	return startTime && endTime ? (
		<TimeWrapper className="marginBottom16">
			<Picker.CustomTime label="Start time" onChange={startTimeHandler} value={dayjs(startTime)} disabled={disabled} />
			<Picker.CustomTime label="End time" onChange={endTimeHandler} value={dayjs(endTime)} disabled={disabled} />
			<Tooltip title="If different, the respective session time will be updated once the note is submitted.">
				<span style={{ marginTop: '24px' }}>
					<CustomButton iconOnly={<InfoFilled />} onClick={() => null} buttonType="secondaryGray" disabled />
				</span>
			</Tooltip>
			<CustomInput label="Duration:" value={findDuration(startTime, endTime)} disabled />
		</TimeWrapper>
	) : null;
};

export default TimeInfo;
